import React from 'react';
import { TextField } from 'react-admin';

import Datagrid from '../common/Datagrid';
import DateField from '../common/fields/DateField';
import NumberCurrencyField from '../common/fields/NumberCurrencyField';
import RecordSplitButton from '../common/buttons/RecordSplitButton';
import CostFrequencyField from './fields/CostFrequencyField';


const CostRow = ({ children, ...props }) => (
    <Datagrid {...props}>
        <TextField source="id" />
        <TextField source="vendor" />
        <TextField source="name" />
        <NumberCurrencyField source="amount" />
        <CostFrequencyField source="frequency" />
        <DateField source="start_date" />
        <DateField source="end_date" />
        <RecordSplitButton />
        {children}
    </Datagrid>
);

export default CostRow;